import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import Flag from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import { ComponentFlagId, HandleDismissedType } from 'src/redux/flags/types';

import { messages } from './offline.i18n';

type Props = {
  id: ComponentFlagId;
  intl: IntlShape;
} & HandleDismissedType;

const OfflineFlag = ({ id, intl, ...otherProps }: Props) => (
  <Flag
    {...otherProps}
    id={id}
    appearance="error"
    icon={
      <StatusErrorIcon
        label="error"
        color={token('color.icon.inverse')}
        spacing="spacious"
      />
    }
    title={intl.formatMessage(messages.offlineTitle)}
    description={intl.formatMessage(messages.offlineDescription)}
  />
);

// eslint-disable-next-line import/no-default-export
export default injectIntl(OfflineFlag);
